import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import Header from "../components/website/Header";
import Footer from "../components/website/Footer";
import RightSideActions from "../components/common/RightSideActions";

export default function WebsiteLayout() {
  return (
    <>
      <Header />
      {/* <main> gives the document its required landmark (a11y). The Suspense
          boundary keeps the Header painted while a lazily-loaded page chunk
          arrives. The fallback reserves a FULL viewport height so the Footer
          stays below the fold during loading — otherwise it paints mid-screen
          and then jumps down when the (taller) page content mounts, which was
          causing a large layout shift (CLS) on direct navigations. */}
      <main>
        <Suspense fallback={<div className="min-h-screen" />}>
          <Outlet />
        </Suspense>
      </main>
      <RightSideActions />
      <Footer />
    </>
  );
}